(function(){
  var FEE_VARIANT=44403739459687;
  var DEFIMG="https://cdn.shopify.com/s/files/1/0677/9682/8263/files/553FC197-B7D6-44FB-AFB6-A6FB8F7F5B3E_c855d617-8f71-4feb-913d-d4da85953468.jpg?v=1785942969";
  var PLIMG={"Bellingham (en stock)":"https://cdn.shopify.com/s/files/1/0677/9682/8263/files/A3ED66BB-E763-4834-8471-28F7A6A11293_edba6226-8379-46a0-9576-e11015b750b3.jpg?v=1786559531","Vinicius Jr (en stock)":"https://cdn.shopify.com/s/files/1/0677/9682/8263/files/830E900D-4483-48B9-B66E-DA6ABF9A123D_53cedf25-02a6-4bc0-9e94-505d484d0d04.jpg?v=1786559531","Mbappé (en stock)":"https://cdn.shopify.com/s/files/1/0677/9682/8263/files/4CB6E4A5-35A4-4023-A200-98E77B6EA70B_4ef903da-4d15-4749-b799-6213e0043efa.jpg?v=1785942952"};
  function M(c){return 'US$ '+(c/100).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2})}
  var $=function(i){return document.getElementById(i)};
  var UPS='<span class="ups">UPS</span>';

  var feeEl=$('glcFee');
  var feePresent = !!(feeEl && (feeEl.getAttribute('data-present')||'').toLowerCase()==='true');
  var feeKey = feeEl ? (feeEl.getAttribute('data-key')||'') : '';

  var hasOrder=false, hasStock=false;
  document.querySelectorAll('#glc-cart .ci').forEach(function(ci){
    var jug=ci.getAttribute('data-jug')||'';
    if(!jug || /en stock/i.test(jug)) hasStock=true; else hasOrder=true;
    var ji=ci.querySelector('.jimg'); if(ji && PLIMG[jug]){ ji.src = PLIMG[jug]; }
  });
  var mixed = hasOrder && hasStock;

  function reload(){ location.reload(); }
  function addFee(){ fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:FEE_VARIANT,quantity:1})}).then(reload).catch(reload); }
  function removeFee(){ if(!feeKey){reload();return;} fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:feeKey,quantity:0})}).then(reload).catch(reload); }

  // Si hay recargo pero el carrito ya no es mixto, lo quitamos automáticamente
  if(feePresent && !mixed){ removeFee(); return; }

  document.querySelectorAll('#glc-cart .ci-price').forEach(function(e){ var c=+e.getAttribute('data-c'); if(!isNaN(c)) e.textContent=M(c); });
  var subEl=$('glcSub'); var SUB=subEl?(+subEl.getAttribute('data-c')||0):0; if(subEl) subEl.textContent=M(SUB);

  var FREE_MIN=15000;
  var FREE = SUB >= FREE_MIN;
  if(FREE && feePresent){ removeFee(); return; }
  var REM = FREE_MIN - SUB;
  var hint = (!FREE && REM>0) ? ' Agrega <b>'+M(REM)+'</b> más y tu envío es <b>GRATIS en USA</b>.' : '';

  var opts=[], note='';
  if(FREE){
    opts=[{c:0,n:'Envío GRATIS (USA)',d:'Tu compra supera US$ 150 · envío gratis en USA · vía UPS'}];
    note='Tu compra califica para <b>ENVÍO GRATIS en USA</b> (US$ 150 o más).';
  } else if(mixed){
    opts=[
      {c:800, mode:'together', n:'Todo en un solo envío', d:'Esperamos el bajo pedido (~2 sem) y enviamos todo junto · vía UPS'},
      {c:1600, mode:'separate', n:'Envíame primero lo disponible', d:'Recibes lo disponible ya; el bajo pedido llega aparte. 2 paquetes · +US$ 8 · vía UPS'}
    ];
    note='Tu carrito tiene productos <b>en stock</b> y <b>bajo pedido</b>. Elige cómo recibirlos: todo junto en <b>un solo envío (US$ 8)</b>, o lo disponible primero en <b>2 envíos (US$ 16)</b>.'+hint;
  } else if(hasOrder){
    opts=[{c:800,n:'Estándar',d:'Flete estándar · vía UPS'},{c:1500,n:'Express',d:'Entrega rápida · vía UPS'}];
    note='Producto <b>bajo pedido</b>: se fabrica en ~2 semanas antes del envío.'+hint;
  } else {
    opts=[{c:800,n:'Estándar',d:'Flete estándar · vía UPS'},{c:1500,n:'Express',d:'Entrega rápida · vía UPS'}];
    note=hint.trim();
  }

  var wrap=document.querySelector('#glc-cart .ship-opts');
  if(wrap){
    var html='';
    for(var i=0;i<opts.length;i++){
      var o=opts[i], pl=(o.c===0?'GRATIS':M(o.c)), md=o.mode?(' data-mode="'+o.mode+'"'):'';
      html+='<div class="so" data-ship="'+o.c+'"'+md+'><span class="so-p">'+pl+'</span><div class="so-n">'+o.n+' '+UPS+'</div><div class="so-d">'+o.d+'</div></div>';
    }
    wrap.innerHTML=html;
  }
  var noteEl=document.querySelector('#glc-cart .ship-note');
  if(!noteEl && note){
    var st=document.querySelector('#glc-cart .ship-t');
    if(st){ noteEl=document.createElement('div'); noteEl.className='ship-note'; st.parentNode.insertBefore(noteEl, st.nextSibling); }
  }
  if(noteEl) noteEl.innerHTML=note;

  var ship=null;
  function render(){ if($('glcShip'))$('glcShip').textContent = ship==null?'Selecciona un método':(ship===0?'GRATIS':M(ship)); if($('glcEst'))$('glcEst').textContent = M(SUB+(ship||0)); }

  function markSel(b){ document.querySelectorAll('#glc-cart .so').forEach(function(x){x.classList.remove('sel')}); if(b) b.classList.add('sel'); }
  function saveAttr(name){ fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{'Método de envío preferido':name}})}).catch(function(){}); }

  function pick(b){
    var mode=b.getAttribute('data-mode');
    if(mode==='separate'){ if(!feePresent){ addFee(); return; } }
    if(mode==='together'){ if(feePresent){ removeFee(); return; } }
    markSel(b); ship=+b.getAttribute('data-ship'); render();
    var label=b.querySelector('.so-n').textContent.replace(/\s+/g,' ').trim();
    saveAttr(label+' ('+M(ship)+')');
  }

  var sos=document.querySelectorAll('#glc-cart .so');
  sos.forEach(function(b){ b.addEventListener('click',function(){pick(b)}); });

  // Selección inicial
  if(mixed && !FREE){
    var sel=null;
    sos.forEach(function(b){ if(b.getAttribute('data-mode')===(feePresent?'separate':'together')) sel=b; });
    if(sel){ markSel(sel); ship=+sel.getAttribute('data-ship'); }
    render();
  } else if(sos.length){ markSel(sos[0]); ship=+sos[0].getAttribute('data-ship'); render(); saveAttr(sos[0].querySelector('.so-n').textContent.replace(/\s+/g,' ').trim()+' ('+M(ship)+')'); }
  else { render(); }

  function change(key,q){ fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:q})}).then(function(r){return r.json()}).then(reload).catch(reload); }
  document.querySelectorAll('#glc-cart .ci').forEach(function(ci){
    var key=ci.getAttribute('data-key'); var q=parseInt(ci.querySelector('.qty span').textContent,10)||1;
    ci.querySelector('[data-a=inc]').addEventListener('click',function(){change(key,q+1)});
    ci.querySelector('[data-a=dec]').addEventListener('click',function(){change(key,Math.max(0,q-1))});
    ci.querySelector('.rm').addEventListener('click',function(){change(key,0)});
  });
})();
